"use client";

import { Core } from "@faire/slate/foundation/color";
import { MediumFormatting } from "@faire/web/common/localization/formatting";
import { Button } from "@faire/web/slate-deprecated/Button";
import { AnnouncementMuted } from "@faire/web/slate/icons/foundation/Announcement";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

export const MutedBrandInsightsTileContents = React.memo(
  ({
    brandName,
    onUndoMuteClick,
  }: {
    brandName: string;
    onUndoMuteClick: () => void;
  }) => {
    return (
      <div className="border-fs-border-muted rounded-fs-component-default flex flex-col items-center justify-center border p-8">
        <AnnouncementMuted fontSize="24px" />
        <Spacer height="1x" />
        <Typography variant="paragraphSansMedium" align="center">
          <StrictLocalMsg
            id="cc+c46"
            defaultMessage="Updates muted"
            description={{
              text: "Title shown to user after successfully change the user preference",
              img: "https://cdn.faire.com/fastly/4699e53715317dfa04d07a67b4dbb565e2fdacf7438358772d5ee220312567aa.png",
            }}
          />
        </Typography>
        <Spacer height="1x" />
        <Typography color={Core.text.subdued} align="center">
          <StrictLocalMsg
            id="vQOqa4"
            defaultMessage="You’ll no longer get updates from <MediumFormatting>{brandCompanyName}</MediumFormatting>."
            values={{
              brandCompanyName: brandName,
              MediumFormatting,
            }}
            description={{
              text: "Message informing user that a brand has been muted",
              img: "https://cdn.faire.com/fastly/4699e53715317dfa04d07a67b4dbb565e2fdacf7438358772d5ee220312567aa.png",
            }}
          />
        </Typography>
        <Spacer height="1x" />
        <Button variant="tertiary" onClick={onUndoMuteClick}>
          <StrictLocalMsg
            id="/T1noR"
            defaultMessage="Undo"
            description={{
              text: "Button to undo the muting of a brand by the user",
              img: "https://cdn.faire.com/fastly/4699e53715317dfa04d07a67b4dbb565e2fdacf7438358772d5ee220312567aa.png",
            }}
          />
        </Button>
      </div>
    );
  }
);
